import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { APP_ROUTES, LOGIN_ERROR_RESPONSE, MESSAGES } from 'app/common/constants';
import { AuthUserService } from 'app/core/services/auth-user.service';
import { ResponseService } from '../../core/services/response.service';

@Component({
  selector: 'app-info-page',
  templateUrl: './info-page.component.html',
  styleUrls: ['./info-page.component.css'],
})
export class InfoPageComponent implements OnInit {
  protected readonly LOGIN_ERROR_RESPONSE = LOGIN_ERROR_RESPONSE;
  text = MESSAGES;
  responseCode = 'ERROR';
  errorMessage: string;
  attemptedEmail: string | null = null;

  constructor(
    private responseService: ResponseService,
    private router: Router,
    private authUserService: AuthUserService
  ) {}

  ngOnInit(): void {
    this.responseService.getResponse().subscribe((res) => {
      this.responseCode = res?.responseCode;
      this.errorMessage = res?.msg;
      const email = res?.attemptedEmail;
      this.attemptedEmail =
        typeof email === 'string' && email.trim().length > 0 ? email.trim() : null;
    });

    if (this.authUserService.isAuthenticated()) {
      this.authUserService.navigateToDefaultOnRole();
      return;
    }
  }

  navigateToMain() {
    localStorage.clear();
    this.router.navigate([APP_ROUTES.MAIN]).then(() => null);
  }
}
